import './teste.css';
import {useState} from 'react';
import { InputMask } from '@react-input/mask';

function Teste(){

    const [cnpj, setCnpj] = useState("");

    function changeCNPJ(e){
        setCnpj(e.target.value);
    }

    function blurCNPJ(){
        console.log(cnpj);
    }


    return(
        <div>
            <h1>Teste</h1>
            <InputMask mask="__.___.___/____-__" 
                       replacement={{ _: /\d/ }} 
                       showMask={false}
                       id="edtCNPJ"
                       name="edtCNPJ"
                       placeholder='CNPJ da empresa'
                       onChange={changeCNPJ}
                       onBlur={blurCNPJ}/>            
        </div>
    )
}

export default Teste;